import { render, staticRenderFns } from "./SmallSpinner.vue?vue&type=template&id=c4d6da3c"
import script from "./SmallSpinner.vue?vue&type=script&lang=js"
export * from "./SmallSpinner.vue?vue&type=script&lang=js"
import style0 from "./SmallSpinner.vue?vue&type=style&index=0&id=c4d6da3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports